module.exports = __webpack_public_path__ + "img/home_p4_icon2.681625e4.png";